import { serverUri } from 'utils/config';
import { BASE64URL_REGEX, JWT_STORAGE } from './constants';

export const getAuthorizationHeader = () => {
  let token: any = localStorage.getItem(JWT_STORAGE) || undefined;
  if (!token) {
    const query = new URLSearchParams(window.location.search);
    token = query.get('token');
    if (token && BASE64URL_REGEX.test(token)) {
      localStorage.setItem(JWT_STORAGE, token);
    } else {
      token = undefined;
    }
  }
  return { Authorization: token ? `Bearer ${token}` : '' };
};

export async function fetchMicrofrontendEntry(name: string) {
  const headers = getAuthorizationHeader();

  try {
    const response = await fetch(`${serverUri}/api/microfrontends/entry/${name}`, {
      method: 'GET',
      headers,
    });

    if (response.ok) {
      const contentType = response.headers.get('content-type');

      if (contentType && contentType.includes('application/json')) {
        const data = await response.json();
        return { data: data, status: response.status };
      } else {
        const textData = await response.text();

        if (textData.startsWith('http')) {
          return { data: textData, status: response.status };
        } else {
          console.error('Received invalid microfrontend URL:', textData);
          return { data: false, status: response.status };
        }
      }
    } else {
      console.error('Error response from server:', response.status);
      return { data: false, status: response.status };
    }
  } catch (error) {
    console.error('Error fetching microfrontend entry:', error);
    return { data: false, status: 500 };
  }
}
